export const classes = {
    HIDDEN: 'hidden',
}

export const FULL_PAGE_LICENSE_KEY = '9ED86121-86B44721-9BB74DAA-6C4DD2B0'
export const SCROLLING_SPEED_FIRST_SECTIONS = 1600
export const SCROLLING_SPEED = 700

/* PAGE LOADER */
export const pageLoader = {
    localStorageId: 'page-loader',
    delayFirstTime: 6000,
    delayOthersTime: 1300,
    bodyClassName: 'page-is-loading',
    delayClassName: 'page-with-delay',
}
